

wpi.mapmodule.getCurrentPosition = function(map, callback) {
  wpi.mapmodule.cleanupGeolocation(map.oneUseGeolocation, 'change');
  map.oneUseGeolocation = null;

  map.oneUseGeolocation = new ol.Geolocation({
    tracking: true, //Required, otherwise it doesn't start getting the data
    trackingOptions: {
      enableHighAccuracy: true,
    },
    projection: map.getView().getProjection()
  });

  map.oneUseGeolocation.on('change', function(evt) { //Wait until first change received
    const xy = map.oneUseGeolocation.getPosition();
    if (!xy || xy.length != 2) {
      wpi.mapmodule.cleanupGeolocation(map.oneUseGeolocation, 'change');
      map.oneUseGeolocation = null;
      callback('xy coordinates could not be retrieved');
      return;
    }
    const curPosData = {
      x: Math.round(xy[0] * 100) / 100,
      y: Math.round(xy[1] * 100) / 100,
      z: wpi.mapmodule.roundIfExistsOrNull(
        wpi.mapmodule.altitudeWGS84ToMN95(
          map.getView().getProjection(), xy,
          map.oneUseGeolocation.getAltitude()
        ), 0
      ),
      xyAccuracy: wpi.mapmodule.roundIfExistsOrNull(map.oneUseGeolocation.getAccuracy(), 2),
      zAccuracy: wpi.mapmodule.roundIfExistsOrNull(map.oneUseGeolocation.getAltitudeAccuracy(), 0)
    };
    wpi.mapmodule.cleanupGeolocation(map.oneUseGeolocation, 'change');
    map.oneUseGeolocation = null;
    callback(null, curPosData);
  });

  map.oneUseGeolocation.on('error', function(err) {
    console.log('Geolocation error: ', err);
    wpi.mapmodule.cleanupGeolocation(map.oneUseGeolocation, 'change');
    map.oneUseGeolocation = null;
    callback(err.message);
  });
}


wpi.mapmodule.altitudeWGS84ToMN95 = function(mapProj, mapCoords, altWGS84) {
  if (!altWGS84) {
    return null;
  }
  // epsg4326 is for WGS84
  coordsinWGS84 = ol.proj.transform(mapCoords, mapProj, 'EPSG:4326');
  // *3600 to convert from decimal degrees to seconds
  lambdaPrime = (coordsinWGS84[0] * 3600 - 26782.5) / 10000;
  phiPrime = (coordsinWGS84[1] * 3600 - 169028.66) / 10000;
  altMN95 = altWGS84 - 49.55 + 2.73 * lambdaPrime + 6.94 * phiPrime;
  return altMN95;
}


wpi.mapmodule.roundIfExistsOrNull = function(val, nbOfDecPlaces) {
  if (!val) {
    return null;
  }
  //apply factor to round to the passed nb of decimal places
  const factor = Math.pow(10, nbOfDecPlaces);
  return Math.round(val * factor) / factor;
}


wpi.mapmodule.showPosition = function(map, panAndZoomToRes, flashingEnabled) {
  if (!map.geolocationObj) {
    map.geolocationObj = new ol.Geolocation({
      tracking : true,
      trackingOptions: {
        enableHighAccuracy: true
      },
      projection: map.getView().getProjection()
    });

    //Possibly needed when first located
    map.geolocationObj.panAndZoomToRes = panAndZoomToRes;

    // handle geolocation error
    map.geolocationObj.on('error', function(err) {
      console.log('Geolocation error: ', err);
      wpi.mapmodule.onGeolocErrored(err.message);
      wpi.mapmodule.hidePosition(map);
    });

    map.geolocationObj.positionFeature = new ol.Feature();
    map.geolocationObj.positionFeature.setStyle(new ol.style.Style({
      image: new ol.style.Circle({
        radius: 6,
        fill: new ol.style.Fill({
          color: 'rgb(51,153,204)'
        }),
        stroke: new ol.style.Stroke({
          color: '#fff',
          width: 2
        })
      })
    }));

    map.geolocationObj.on('change:position', function() {
      var coordinates = map.geolocationObj.getPosition();
      map.geolocationObj.positionFeature.setGeometry(coordinates ? new ol.geom.Point(coordinates) : null);
      if (map.geolocationObj.panAndZoomToRes > 0) {
        map.getView().animate({
          center: coordinates,
          resolution: map.geolocationObj.panAndZoomToRes
        });
        map.geolocationObj.panAndZoomToRes = 0; //Do just once, at start
      }
    });

    var posLayer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [ map.geolocationObj.positionFeature] //accuracyFeature may be added in this list
      })
    });
    posLayer.key = "___poslayer___";

    map.addLayer(posLayer);
  }

  if (flashingEnabled) {
    wpi.mapmodule.startFlashing(map, map.geolocationObj.positionFeature, 3000);
  } else {
    wpi.mapmodule.stopFlashing(map);
  }
};




wpi.mapmodule.hidePosition = function(map) {
  wpi.mapmodule.stopFlashing(map);
  wpi.mapmodule.cleanupGeolocation(map.geolocationObj, 'change:position');
  map.geolocationObj = null;
  var layers = map.getLayers().getArray();
  for (var i=0; i<layers.length; i++) {
    if (layers[i].key === "___poslayer___") {
      map.removeLayer(layers[i]);
      break;
    }
  }
};




wpi.mapmodule.startFlashing = function(map, feature, duration) {
  var start;

  function animate(event) {
    if (!feature || !feature.getGeometry()) return;

    if (!start) {
      start = new Date().getTime();
    }
    var vectorContext = event.vectorContext;
    var flashGeom = feature.getGeometry().clone();
    var elapsed = event.frameState.time - start;
    var elapsedRatio = elapsed / duration;
    if (elapsedRatio > 1) elapsedRatio = 1;
    // radius will be 5 at start and 30 at end.
    var radius = ol.easing.easeOut(elapsedRatio) * 25 + 5;
    var opacity = ol.easing.easeOut(1 - elapsedRatio);

    var style = new ol.style.Style({
      image: new ol.style.Circle({
        radius: radius,
        snapToPixel: false,
        stroke: new ol.style.Stroke({
          color: 'rgba(51,153,204, ' + opacity + ')',
          width: 0.25 + opacity
        })
      })
    });

    vectorContext.setStyle(style);
    vectorContext.drawGeometry(flashGeom);
    if (elapsed > duration) {
      start = null;
    }
    //tell OpenLayers to continue postcompose animation
    map.render();
  }

  if (!map.postComposeKey) {
    map.postComposeKey = map.on('postcompose', animate);
  }
};




wpi.mapmodule.stopFlashing = function(map) {
  if (map.postComposeKey) {
    ol.Observable.unByKey(map.postComposeKey);
    map.postComposeKey = null;
  }
};




wpi.mapmodule.cleanupGeolocation = function(geoloc, eventName) {
  if (geoloc) {
    geoloc.un(eventName);
    geoloc.setTracking(false);
    geoloc = null;
  }
}
